import * as actions from '../actions/assigned';

const getInitialState = () => ({
  data: null,
  error: null,
  loaded: false,
  loading: false,
});

const assignedReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case actions.ASSIGNED_DIVS_FETCH: {
      return {
        data: {
          orgId: action.payload.orgId,
          divisions: [],
        },
        error: null,
        loaded: false,
        loading: true,
      };
    }
    case actions.ASSIGNED_DIVS_FETCH_ERROR: {
      return {
        data: null,
        error: action.payload,
        loaded: true,
        loading: false,
      };
    }
    case actions.ASSIGNED_DIVS_FETCH_SUCCESS: {
      return {
        data: {
          orgId: state.data.orgId,
          divisions: action.payload.divisions,
        },
        error: null,
        loaded: true,
        loading: false,
      };
    }
    case actions.ASSIGNED_DIVISION_REMOVE: {
      const { divisionId } = action.payload;
      const currentDivisions = state.data?.divisions;

      if (
        !currentDivisions ||
        Array.isArray(currentDivisions) ||
        !(divisionId in currentDivisions)
      ) {
        return state;
      }

      const { [divisionId]: _removed, ...remainingDivisions } = currentDivisions;

      return {
        ...state,
        data: {
          ...state.data,
          divisions: remainingDivisions,
        },
      };
    }

    default:
      return state;
  }
};

export default assignedReducer;
